import * as React from "react";
import {useMemo, useState} from "react";
import {Link} from "react-router-dom";
import {MessageState} from "src/domain/model/user";
import {Customer} from "../../../../domain/model/customer";
import {INotificationRepository} from "../../../../domain/repository/notification_repository";
import {createApiClient, IApiClient} from "../../../../infra/api/client";
import {entity} from "../../../../infra/api/rpc/api";
import {createNotificationAPI} from "../../../../infra/api/service/notification_api";
import LayoutSearchFormForMenu from "../../../component/layout/share/layout_search_form";
import AvatarProfile from "../../molecular/avatar_profile/avatar_profile";
import {
    ChildLinkWrapper,
    ChildOpenBtn,
    ChildrenWrapper,
    FlexWrapper,
    IconText,
    LinkText,
    MainContentWrapper,
    ParentLinkWrapper,
    StyleLink,
    UserMenuWrapper,
} from "./menu_share_components";
import UnReadCount from "./unread_count";

const apiClient: IApiClient = createApiClient();
const notificationRepository: INotificationRepository =
    createNotificationAPI(apiClient);

interface IProps {
    customer: Customer | null;
    messageStateList: MessageState[];
    handleSearchForCustomer: (values: any) => void;
    handleCloseMenu: (event: React.MouseEvent<HTMLElement>) => void;
}

const CustomerMenu: React.FC<IProps> = (props) => {
    const {
        customer,
        messageStateList,
        handleSearchForCustomer,
        handleCloseMenu,
    } = props;

    if (!customer) {
        return null;
    }

    const customerName: string = customer.name;
    // polling のgetMe時に毎回画像を取りに走っているためMemo化
    const customerIconURL = useMemo(
        () => customer.getIconURL(),
        [customer.gsIconURL]
    );

    const [isOpenMypage, setIsOpenMypage] = useState(false);

    const toggleIsOpenMypage = () => {
        setIsOpenMypage(!isOpenMypage);
    };

    const handleLinkClick =
        (setFn?: (value: any) => void) =>
            (event: React.MouseEvent<HTMLElement>) => {
                if (setFn) {
                    setFn(true);
                }
                handleCloseMenu(event);
            };

    const [notificationUnReadCount, setNotificationUnReadCount] = useState(0);

    React.useEffect(() => {
        notificationRepository.getUnReadCount().then((count) => {
            setNotificationUnReadCount(count);
        });
    }, []);

    return (
        <UserMenuWrapper>
            <FlexWrapper>
                <MainContentWrapper>
                    <LayoutSearchFormForMenu
                        onSubmit={handleSearchForCustomer}
                        form={"CustomerProjectsSearchForm"}
                        initialValues={{
                            placeholder: "案件の検索",
                        }}
                    />
                    <Link to={`/customer/mypage/customer`}>
                        <AvatarProfile
                            avatarURL={customerIconURL}
                            avatarName={customerName}
                        />
                    </Link>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/customer`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f2c2'"}>
                                ダッシュボード
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper isOpen={isOpenMypage}>
                        <StyleLink
                            to={`/customer/mypage/customer`}
                            onClick={handleLinkClick(setIsOpenMypage)}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f007'"} iconPrefix={"400"}>
                                マイページ
                            </LinkText>
                        </StyleLink>
                        <ChildOpenBtn isOpen={isOpenMypage} onClick={toggleIsOpenMypage}>
                            <IconText icon={isOpenMypage ? "'\f00d'" : "'\f067'"}/>
                        </ChildOpenBtn>
                    </ParentLinkWrapper>

                    <ChildrenWrapper isOpen={isOpenMypage}>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/customer/mypage/customer/_edit`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>マイページ編集</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/customer/blacklist/_edit`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>企業ブロック</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/customer/mypage/email`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>メールアドレス変更</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/customer/mypage/password`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>パスワード変更</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                    </ChildrenWrapper>

                    {customer.type !== entity.Customer.Type.Type_Pro && (
                        <ParentLinkWrapper>
                            <StyleLink
                                to={`/customer/projects`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true} icon={"'\f0ae'"}>
                                    案件
                                </LinkText>
                            </StyleLink>
                        </ParentLinkWrapper>
                    )}
                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/customer/project-sharing`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f0ae'"}>
                                案件シェアリング
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/customer/operations`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f024'"}>
                                稼働報告
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    {/*<ParentLinkWrapper>
                        <StyleLink
                            to={
                                localStorage.getItem("partnerStoreTermsAccepted") === "1"
                                    ? `/customer/partner-store-list`
                                    : `/customer/partner-store`
                            }
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f0ae'"}>
                                パートナーストア
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>*/}

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/customer/notifications`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f0f3'"}>
                                お知らせ
                            </LinkText>
                            {notificationUnReadCount > 0 && (
                                <UnReadCount count={notificationUnReadCount} withIcon={false}/>
                            )}
                        </StyleLink>
                    </ParentLinkWrapper>

                    {customer.type !== entity.Customer.Type.Type_Pro && (
                        <ParentLinkWrapper>
                            <StyleLink
                                to={`/customer/entries`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true} icon={"'\f0eb'"}>
                                    エントリー履歴
                                </LinkText>
                            </StyleLink>
                        </ParentLinkWrapper>
                    )}

                    {customer.type !== entity.Customer.Type.Type_Pro && (
                        <ParentLinkWrapper>
                            <StyleLink
                                to={`/customer/messages`}
                                target="_blank"
                                rel="noopener"
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true} icon={"'\f075'"} iconPrefix={"400"}>
                                    メッセージ
                                </LinkText>
                                <UnReadCount
                                    count={messageStateList.reduce(
                                        (sum: number, val: MessageState) => {
                                            return sum + Number(`${val.unReadCount}`);
                                        },
                                        0
                                    )}
                                    withIcon={true}
                                />
                            </StyleLink>
                        </ParentLinkWrapper>
                    )}
                </MainContentWrapper>
            </FlexWrapper>
        </UserMenuWrapper>
    );
};

export default CustomerMenu;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/menu/customer_menu.tsx